"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidZipCodeFormat = void 0;
const regex_1 = require("../../constants/regex");
const is_string_1 = require("../is-string/is-string");
/**
 * Returns true if the string is a valid ZIP code
 * @public
 *
 * @param  arg - A generic argument to check
 * @returns true if the string is a valid ZIP code
 *
 *
 * @example
 * ```ts
 * const result = isValidZipCodeFormat('90210');
 * console.log(result);
 * // -> true
 * ```
 **/
function isValidZipCodeFormat(arg) {
    return (0, is_string_1.isString)(arg) && regex_1.ZIP_CODE_REGEX.test(arg);
}
exports.isValidZipCodeFormat = isValidZipCodeFormat;
//# sourceMappingURL=is-valid-zip-code-format.js.map